export default {
  name: 'Beneficial Bio',
  domain: 'beneficialbio',
  id: '5ff3403ce02c9c0001189fc8',
  slug: 'beneficialbio',
  path: '/beneficialbio/',
  logo: '/partners/beneficialbio/img/logo.png',
  themes: {
    light: {
      primary: '#04447b',
      secondary: '#26AAE2',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#26AAE2',
      success: '#8bc34a',
      appbar: '#FFFFFF',
      // background: '#004578',
    },
  },
};
